const useSortedPerAvailabilityList = <T extends TCategories | TPart[]>(
  groups: T
): T => {
  return groups.sort((a, b) => {
    if (a.total_products > 0 && b.total_products === 0) {
      return -1;
    } else if (a.total_products === 0 && b.total_products > 0) {
      return 1;
    }
    return 0;
  }) as T;
};

export default useSortedPerAvailabilityList;
